export const onRouteUpdate = ({ location }) => {
    // Redirect non-trailing slash to trailing slash on client side
    if (!location.pathname.endsWith('/') && !location.pathname.includes('.')) {
      window.history.replaceState(null, '', location.pathname + '/');
    }
  };